import { render, staticRenderFns } from "./ArticlePriceGraph.vue?vue&type=template&id=5c2d4a97&"
import script from "./ArticlePriceGraph.vue?vue&type=script&lang=js&"
export * from "./ArticlePriceGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports